@if (isVisible$ | async; as isVisible) {
    <div class="loading" [hidden]="!isVisible">
        <span>{{ fallbackMessage }}</span>
    </div>
}
